import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
import {
  Box,
  Typography,
  Grid,
  Button,
  Divider,
  Paper,
  IconButton,
  Chip, Dialog, Snackbar, TextField
} from "@mui/material";
import { ShoppingBag } from "@mui/icons-material";
import moment from 'moment';
import { useGetListOrdersMutation, useGetOrderDetailsMutation, useCancelOrderMutation } from "../../services/orders";
const API_URI = process.env.REACT_APP_API_URI;

const ordersData = [
  {
    id: 1,
    shop: "Uniqlo Vietnam",
    status: "Đã giao hàng",
    date: "20/10/2025",
    items: [
      {
        name: "Áo thun cotton cổ tròn",
        price: 199000,
        quantity: 2,
        image:
          "https://down-vn.img.susercontent.com/file/vn-11134207-7r98o-lszgbcc6r8pr73",
      },
      {
        name: "Quần short kaki nam",
        price: 299000,
        quantity: 1,
        image:
          "https://down-vn.img.susercontent.com/file/vn-11134207-7r98o-lrmyr3cw7w8m6e",
      },
    ],
  },
  {
    id: 2,
    shop: "Canifa Official Store",
    status: "Đang giao hàng",
    date: "21/10/2025",
    items: [
      {
        name: "Áo sơ mi nữ linen",
        price: 359000,
        quantity: 1,
        image:
          "https://down-vn.img.susercontent.com/file/vn-11134207-7r98o-lt5mtr4h89m9b1",
      },
    ],
  },
];

export default function OrderList() {
  const [getListOrders, listOrdersResult] = useGetListOrdersMutation();
  const [getOrderDetails, orderDetailsResult] = useGetOrderDetailsMutation();
  const [cancelOrder, cancelOrderResult] = useCancelOrderMutation();
  const [orders, setOrders] = useState(ordersData);
  const [openDetail, setOpenDetail] = useState(false);
  const [details, setDetails] = useState([]);
  const [openCancel, setOpenCancel] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState({});
  const [alert, setAlert] = useState(false);
  const [status, setStatus] = useState(['0']);
  const infor = useSelector(state => state.authUser.infor) || {};

  useEffect(() => {
    getListOrders({status: status.length?status[0]:0});
  }, []);

  useEffect(() => {
    if(listOrdersResult.data)
    {
      const dt = JSON.parse(listOrdersResult.data);
      setOrders(dt);
    }
  }, [listOrdersResult]);

  useEffect(() => {
    if(orderDetailsResult.data)
    {
      const dt = JSON.parse(orderDetailsResult.data);
      setDetails(dt);
    }
  }, [orderDetailsResult]);

  const showDetail = (record) => {
    setSelectedRecord(record);
    getOrderDetails({orderid: record.id});
    setOpenDetail(true);
  };

  const handleCancel = (record) => {
    setSelectedRecord(record);
    setOpenCancel(true);
  };

  const onCancel = async() => {
    const result = await cancelOrder({orderid: selectedRecord.id});
    if (!result || result.error) {
      setAlert("Lỗi kết nối, vui lòng thử lại!");
    }
  };

  useEffect(() => {
    if(cancelOrderResult.data)
    {
      const dt = JSON.parse(cancelOrderResult.data);
      if(dt.length && dt[0].ID){
        setAlert("Hủy đơn hàng thành công!");
        getListOrders({status: status.length?status[0]:0});
        setOpenCancel(false);
      }
      else{
        if(dt.length && dt[0].ERROR)
          setAlert(dt[0].ERROR);
        else
          setAlert("Lỗi kết nối vui lòng thử lại sau!");
      }
    }
  }, [cancelOrderResult]);

  const onSelectStatus=(value)=>{
		// let pg = [...status];
		// if(pg.includes(value))
		// 	pg = pg.filter(f=>f!=value);
		// else
		// 	pg.push(value);

		// setStatus(pg);

		// getListOrders({status: pg});
    setStatus([value]);
    getListOrders({status: value});
	}

  return (
    <Box sx={{ p: { xs: 2, md: 4 }, bgcolor: "#fafafa", minHeight: "100vh" }}>
      <Typography variant="h5" fontWeight="bold" sx={{ mb: 1 }}>
        Đơn hàng của tôi
      </Typography>
      <Box sx={{mb: 2}}>
        <Chip
          key={'0'}
          label={"Chờ xác nhận"}
          variant="outlined"
          sx={{
            minWidth: 50,
            textAlign: "center",
            bgcolor: status.includes("0") ? "cyan" : "transparent",
            cursor: 'pointer',
            mr: 1
          }}
          onClick={()=>onSelectStatus("0")}
        />
        <Chip
          key={'6'}
          label={"Đã giao"}
          variant="outlined"
          sx={{
            minWidth: 50,
            textAlign: "center",
            bgcolor: status.includes("6") ? "cyan" : "transparent",
            cursor: 'pointer',
            mr: 1
          }}
          onClick={()=>onSelectStatus("6")}
        />
        <Chip
          key={'-1'}
          label={"Hủy"}
          variant="outlined"
          sx={{
            minWidth: 50,
            textAlign: "center",
            bgcolor: status.includes("-1") ? "cyan" : "transparent",
            cursor: 'pointer',
            mr: 1
          }}
          onClick={()=>onSelectStatus("-1")}
        />
        <Chip
          key={'-2'}
          label={"Tất cả"}
          variant="outlined"
          sx={{
            minWidth: 50,
            textAlign: "center",
            bgcolor: status.includes("-2") ? "cyan" : "transparent",
            cursor: 'pointer',
            mr: 1
          }}
          onClick={()=>onSelectStatus("-2")}
        />
      </Box>
      <Grid container spacing={2}>
        {orders.map((order) => {
          // const total = order.items.reduce(
          //   (sum, i) => sum + i.price * i.quantity,
          //   0
          // );
          return (
            <Grid item xs={12} key={order.id}>
              <Paper
                sx={{
                  p: 2,
                  borderRadius: 2,
                  boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
                }}
              >
                {/* Header */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexWrap: "wrap",
                    mb: 1,
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <ShoppingBag fontSize="small" color="primary" />
                    <Typography fontWeight={600}>{order.orderno}</Typography>
                    <Chip
                      label={order.statusname}
                      color={
                        order.status==3
                          ? "success" : order.status==-1 ? "error"
                          : "warning"
                      }
                      size="small"
                      sx={{ ml: 1, width: '100px' }}
                    />
                  </Box>
                  <Typography variant="body2" color="text.secondary" sx={{ml: 1}}>
                    Ngày đặt: {order.createdat?moment(order.createdat).format("DD/MM/YYYY"):""}
                  </Typography>
                </Box>

                <Divider sx={{ mb: 2 }} />
                <Typography variant="body2" color="text.secondary" sx={{ml: 1}}>
                  Hóa đơn điện tử: {order.einvoice}
                </Typography>

                <Divider sx={{ my: 1 }} />

                {/* Footer */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexWrap: "wrap",
                    mt: 1,
                    gap: 1,
                  }}
                >
                  <Typography color="text.secondary">
                    Tổng cộng:{" "}
                    <Typography
                      component="span"
                      fontWeight={700}
                      color="error.main"
                    >
                      {(order.totalmoney||0).toLocaleString()}₫
                    </Typography>
                  </Typography>

                  <Box>
                    {
                      order.status == 0?
                    <Button
                      variant="outlined"
                      color="warning"
                      sx={{ fontWeight: 600, borderRadius: 10, px: 3 }}
                      onClick={()=>handleCancel(order)}
                    >Hủy</Button>
                    :''}
                    <Button
                      variant="outlined"
                      color="primary"
                      sx={{ fontWeight: 600, borderRadius: 10, px: 3, ml: 1 }}
                      onClick={()=>showDetail(order)}
                    >Chi tiết</Button>
                  </Box>
                </Box>
              </Paper>
            </Grid>
          );
        })}
      </Grid>

      <Dialog onClose={()=>setOpenDetail(false)} open={openDetail} maxWidth="md" fullWidth 
        sx={{ "& .MuiDialog-paperFullWidth": {m: {xs: 1, md: 4}, width: '100%', maxHeight: {xs: '98vh', md: '90vh'}} }}>
        <Grid container spacing={2} sx={{justifyContent: "center"}}>
          {/* LEFT: Product list */}
          <Grid item xs={12} md={8} sx={{ width: {xs: "100%", md: "auto"} }}>
            <Paper sx={{ p: 2 }}>
              <Typography fontWeight={600}>Danh Sách Sản Phẩm</Typography>
              {details.map((item) => (
                <Box
                  key={item.id}
                  sx={{
                    display: "flex",
                    flexDirection: { xs: "column", sm: "row" },
                    alignItems: { xs: "flex-start", sm: "center" },
                    gap: 2,
                    py: 2,
                    borderBottom: "1px solid #eee"
                  }}
                >
                  <Box sx={{ display: "flex", flexDirection: "row" }}>
                    <Box
                      component="img"
                      src={(item.Images?`${API_URI}/uploads/products/${item.Images}`:'') || item.ImageSrcs}
                      alt="&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;  
                            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; No_Image"
                      sx={{
                        width: 100,
                        height: 100,
                        objectFit: "cover",
                        borderRadius: 2,
                        border: "1px solid #eee",
                        textAlign: "center", lineHeight: '18px', color: 'silver'
                      }}
                    />
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    <Typography fontWeight={600}>{item.ProductName}</Typography>
                    <Typography color="text.secondary" variant="body2">
                      Mã: {item.StyleNo} | Màu: {item.Colors} | Kích cỡ: {item.size}
                    </Typography>
  
                    {/* Quantity & Price */}
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "flex-start",
                        mt: 1,
                        flexWrap: "wrap",
                        flexDirection: "column"
                      }}
                    >
                      Số lượng: {item.quantity}
                    </Box>
  
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1 }}>
                      <Typography variant="body1" sx={{ color: 'red', fontWeight: 'bold' }}>
                        {item.saleprice?item.saleprice.toLocaleString('en-US'):0}₫
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{ textDecoration: 'line-through', color: '#888' }}
                      >
                        {item.price?item.price.toLocaleString('en-US'):0}₫
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              ))}
            </Paper>
          </Grid>
  
          {/* RIGHT: Summary */}
          <Grid item xs={12} md={4} sx={{ width: {xs: "100%", md: "auto"} }}>
            <Paper sx={{ p: 3, position: "sticky", top: 80 }}>
              <Typography variant="h6" fontWeight={600}>
                Tóm tắt đơn hàng
              </Typography>
              <Divider sx={{ my: 2 }} />
  
              <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                <Typography>Số lượng sản phẩm:</Typography>
                <Typography fontWeight={600}>
                  {details.length && details.reduce((sum, i) => sum + i.quantity, 0)}
                </Typography>
              </Box>
  
              <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                <Typography>Cộng tiền hàng:</Typography>
                <Typography fontWeight={600} color="error.main">
                  {(selectedRecord.totalgross||0).toLocaleString()}₫
                </Typography>
              </Box>
  
              <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                <Typography>Tổng trước VAT:</Typography>
                <Typography fontWeight={600}>
                  {(selectedRecord.totalamount||0).toLocaleString()}₫
                </Typography>
              </Box>
  
              <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                <Typography>Chiết khấu {infor.CBDDiscount||0}%:</Typography>
                <Typography fontWeight={600}>
                  - {(selectedRecord.otherdiscount||0).toLocaleString()}₫
                </Typography>
              </Box>
  
              <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                <Typography>VAT:</Typography>
                <Typography fontWeight={600}>
                  {(selectedRecord.vatmoney||0).toLocaleString()}₫
                </Typography>
              </Box>
  
              <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                <Typography fontWeight={600}>Tổng thanh toán:</Typography>
                <Typography fontWeight={600} color="blue" sx={{ml: 2}}>
                  {(selectedRecord.lastmoney||0).toLocaleString()}₫
                </Typography>
              </Box>
            </Paper>
          </Grid>
        </Grid>
        {/* {details.map((item, idx) => (
          <Box
            key={idx}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
              flexWrap: "wrap",
              m: 2
            }}
          >
            <Avatar
              src={item.imagesrc}
              variant="rounded"
              sx={{
                width: 70,
                height: 70,
                border: "1px solid #eee",
                flexShrink: 0,
              }}
            />
            <Box sx={{ flex: 1 }}>
              <Typography
                variant="body1"
                fontWeight={500}
                sx={{
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                }}
              >
                {item.productname}
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ mt: 0.5 }}
              >
                Màu: {item.color} | Kích cỡ: {item.sizecup}
              </Typography>
              <Typography
                variant="body2"
                sx={{ mt: 0.5 }}
              >
                Số lượng: {item.quantity}
              </Typography>
            </Box>
            <Box>
                <Typography
                  variant="body1"
                  fontWeight={600}
                  color="error.main"
                >
                  {item.saleprice?item.saleprice.toLocaleString():0}₫
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ textDecoration: 'line-through', color: '#888', textAlign: 'right' }}
                >
                  {item.price?item.price.toLocaleString('en-US'):0}₫
                </Typography>
            </Box>
          </Box>
        ))} */}
      </Dialog>
      <Dialog onClose={()=>setOpenCancel(false)} open={openCancel} maxWidth="sm">
        <Box sx={{m: 2, textAlign: 'center'}}>
          <Typography
            variant="body1"
            fontWeight={600}
            color="error.main"
          >
            Xác nhận hủy đơn hàng?
          </Typography>
          <Box sx={{mt: 2}}>
            <Button
              variant="outlined"
              color="primary"
              sx={{ fontWeight: 600, borderRadius: 10, px: 3 }}
              onClick={()=>setOpenCancel(false)}
            >Đóng</Button>

            <Button
              variant="outlined"
              color="primary"
              sx={{ fontWeight: 600, borderRadius: 10, px: 3, ml: 1 }}
              onClick={()=>onCancel()}
              disabled={cancelOrderResult.isLoading}
            >Xác Nhận</Button>
          </Box>
        </Box>
      </Dialog>

      <Snackbar
        open={alert}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        autoHideDuration={6000}
        onClose={()=>setAlert(false)}
        message={alert}
        // action={action}
      />
    </Box>
  );
}
